import axios from 'axios';

import { apiRoutes } from '~/client/config/routes';
import { saveFile } from '~/client/utils/file';
import { keyOutcomesReportFilename } from '~/common/utils/activityReport';

export const downloadKeyOutcomesReport = async (from?: string, to?: string) => {
  const { data } = await axios.get<Blob>(apiRoutes.keyOutcomesReport(from, to), {
    responseType: 'blob',
  });

  saveFile(data, keyOutcomesReportFilename(from, to));
};
